import React, { useState } from 'react'
import { Location } from '@reach/router'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { colors, md } from '../common'

export default ({ data }) => {
  const [ showFilters, setShow ] = useState(false)

  function toggleFilters() {
    setShow(!showFilters)
  }

  const hideStyles = `width:0;height:0;padding:0;margin:0;font-size:0;border:0;`

  return(
    <Location>
      {({ location }) => {
        return  <div>
                  <MobileFiltersBtn onClick={toggleFilters}>
                    <p css={`text-transform: uppercase`}>{ showFilters ? 'hide' : 'show' } filters</p>
                  </MobileFiltersBtn>
                  <ButtonSection showMobile={ showFilters ? '' : hideStyles }>
                  <div css={`display:flex;flex-direction:column;`}>
                    <p>Filter by Type:</p>
                    <FilterBtn hideMobile={ showFilters ? '' : hideStyles } to={'/products/diamond'} active={(location.pathname === '/products/diamond') ? true : false }>Diamond</FilterBtn>
                    <FilterBtn hideMobile={ showFilters ? '' : hideStyles } to={'/products/colored'} active={(location.pathname === '/products/colored') ? true : false }>Gemstone</FilterBtn>
                    <FilterBtn hideMobile={ showFilters ? '' : hideStyles } to={'/products/earring'} active={(location.pathname === '/products/earring') ? true : false }>Earrings</FilterBtn>
                    <FilterBtn hideMobile={ showFilters ? '' : hideStyles } to={'/products/ring'} active={(location.pathname === '/products/ring') ? true : false }>Rings</FilterBtn>
                    <FilterBtn hideMobile={ showFilters ? '' : hideStyles } to={'/products/engagement'} active={(location.pathname === '/products/engagement') ? true : false }>Engagement Rings</FilterBtn>
                    <FilterBtn hideMobile={ showFilters ? '' : hideStyles } to={'/products/fashion'} active={(location.pathname === '/products/fashion') ? true : false }>Fashion</FilterBtn>
                    <FilterBtn hideMobile={ showFilters ? '' : hideStyles } to={'/products/necklace'} active={(location.pathname === '/products/necklace') ? true : false }>Necklace</FilterBtn>
                    <FilterBtn hideMobile={ showFilters ? '' : hideStyles } to={'/products/pendant'} active={(location.pathname === '/products/pendant') ? true : false }>Pendant</FilterBtn>
                    <FilterBtn hideMobile={ showFilters ? '' : hideStyles } to={'/products/bracelet'} active={(location.pathname === '/products/bracelet') ? true : false }>Bracelets</FilterBtn>
                    <FilterBtn hideMobile={ showFilters ? '' : hideStyles } to={'/products/wedding'} active={(location.pathname === '/products/wedding') ? true : false }>Wedding Bands</FilterBtn>
                    <FilterBtn hideMobile={ showFilters ? '' : hideStyles } to={'/products/silver'} active={(location.pathname === '/products/silver') ? true : false }>Silver</FilterBtn>
                    <FilterBtn hideMobile={ showFilters ? '' : hideStyles } to={'/products/'}>All Styles</FilterBtn>
                  </div>
                  <div css={`display:flex;flex-direction:column;`}>
                    <p>Featured Designer:</p>
                    <FilterBtn hideMobile={ showFilters ? '' : hideStyles } to={'/products/kit-heath'} active={(location.pathname === '/products/kit-heath') ? true : false }>Kit Heath</FilterBtn>
                    <FilterBtn hideMobile={ showFilters ? '' : hideStyles } to={'/products/belle-etoile'} active={(location.pathname === '/products/belle-etoile') ? true : false }>Belle Etoile</FilterBtn>
                    <FilterBtn hideMobile={ showFilters ? '' : hideStyles } to={'/products/lika-behar'} active={(location.pathname === '/products/lika-behar') ? true : false }>Lika Behar</FilterBtn>
                    <FilterBtn hideMobile={ showFilters ? '' : hideStyles } to={'/products/simon-g'} active={(location.pathname === '/products/simon-g') ? true : false }>Simon G.</FilterBtn>
                    <FilterBtn hideMobile={ showFilters ? '' : hideStyles } to={'/products/'}>All Designers</FilterBtn>
                  </div>
                  <div css={`display:flex;flex-direction:column;`}>
                    <p>Clear All Filters:</p>
                    <FilterBtn hideMobile={ showFilters ? '' : hideStyles } to={'/products/'}>View All Products</FilterBtn>
                  </div>
                </ButtonSection>
                </div>
      }}
    </Location>
  )
}

const ButtonSection = styled.div`
  width: 200px;
  padding: 10px;

  ${md} {
    width: 90%;
    ${ props => props.showMobile }
  }
`

const FilterBtn = styled(Link)`
  padding: 8px;
  font-size: 16px;
  background-color: #fff;
  border-radius: 0;
  color: ${colors.brownDark};
  border: 1px solid ${colors.brownLight};
  margin-top: 3px;
  width: 100%;
  text-align: left;

  ${props => (props.active) ? `background-color:${colors.brownDark};color:#fff` : ''};
  :focus {
    outline: 0;
  }
  :active {
    background-color: ${colors.brownDark};
    color: #fff;
  }

  ${md} {
    ${ props => props.hideMobile }
  }
`

const MobileFiltersBtn = styled.div`
  background-color: ${colors.brown};
  color: #fff;
  padding: 10px;
  text-align: center;
  display: none;
  ${md} {
    display: block;
  }
`
